import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Keeps a spec table in sync with the selected variant.
 *
 * Horizon's <variant-picker> re-fetches the full product page on every variant
 * change and dispatches `variant:update` with the parsed HTML in
 * `event.detail.data.html`. We pull our own re-rendered table (matched by id)
 * out of that HTML and morph it in — so any variant-dependent `liquid_value`
 * row reflects the new variant. Same pattern as product-inventory.js.
 *
 * Listens on `document` so it works regardless of which section the block is
 * placed in. Scoped by product id + block id, so it never reacts to a
 * different product's variant change (e.g. a featured product or quick-add).
 */
class JgdSpecTable extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.updateSpecTable);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecTable);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateSpecTable = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const updated = event.detail.data.html.querySelector(`jgd-spec-table[id="${this.id}"]`);

    if (!updated) return;

    morph(this, updated, { childrenOnly: true });
  };
}

if (!customElements.get('jgd-spec-table')) {
  customElements.define('jgd-spec-table', JgdSpecTable);
}
